module.exports = import("insights");;